
import React, { useState, useEffect } from 'react';
import { Shield } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface AdminRoleIndicatorProps {
  userId: string;
  checkAdminStatus: (userId: string) => Promise<boolean>;
  showText?: boolean;
}

export const AdminRoleIndicator: React.FC<AdminRoleIndicatorProps> = ({ 
  userId, 
  checkAdminStatus, 
  showText = false 
}) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchAdminStatus = async () => {
      setLoading(true);
      const status = await checkAdminStatus(userId);
      setIsAdmin(status);
      setLoading(false);
    };
    
    fetchAdminStatus();
  }, [userId, checkAdminStatus]);
  
  if (loading) {
    return (
      <span className="inline-flex h-5 w-5 animate-pulse rounded-full bg-muted"></span>
    );
  }
  
  if (isAdmin) {
    return (
      <Badge variant="purple" className="gap-1">
        <Shield className="h-3 w-3" />
        {showText && "Admin"}
      </Badge>
    );
  }
  
  return showText ? (
    <Badge variant="outline">Utilisateur standard</Badge>
  ) : null;
};
